<template>
  <el-dialog
    :title="$t('demo.addDemo')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="addDemoInfo" :rules="rules" ref="addDemoForm" label-width="120px">
      <el-form-item :label="$t('demo.demoName')" prop="demoName">
        <el-input 
          v-model="addDemoInfo.demoName" 
          :placeholder="$t('demo.requiredDemoName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('demo.demoValue')" prop="demoValue">
        <el-input 
          v-model="addDemoInfo.demoValue" 
          :placeholder="$t('demo.requiredDemoValue')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('demo.demoRemark')" prop="demoRemark">
        <el-input 
          v-model="addDemoInfo.demoRemark" 
          :placeholder="$t('demo.optionalDemoRemark')"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('demo.cancel') }}</el-button>
      <el-button type="primary" @click="saveDemoInfo">{{ $t('demo.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveDemoConfig } from '@/api/dev/demoApi'

export default {
  name: 'AddDemo',
  data() {
    return {
      dialogVisible: false,
      addDemoInfo: {
        demoName: '',
        demoValue: '',
        demoRemark: ''
      },
      rules: {
        demoName: [
          { required: true, message: this.$t('demo.requiredDemoName'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('demo.demoNameLength'), trigger: 'blur' }
        ],
        demoValue: [
          { required: true, message: this.$t('demo.requiredDemoValue'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('demo.demoValueLength'), trigger: 'blur' }
        ],
        demoRemark: [
          { max: 200, message: this.$t('demo.demoRemarkMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addDemoForm.resetFields()
    },
    async saveDemoInfo() {
      try {
        await this.$refs.addDemoForm.validate()
        await saveDemoConfig(this.addDemoInfo)
        this.$message.success(this.$t('demo.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        if (error !== 'validate') {
          this.$message.error(this.$t('demo.saveFailed'))
        }
      }
    }
  }
}
</script>